import * as _fetch from './src/fetch';
export const fetch = _fetch;

export * from './src/proxy';
export * from './src/types';
